import React, { useState } from 'react'
import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";
import { Link } from 'react-router-dom';

const icons = [
  { name: "Coffee Shop", icon: <FaCoffee /> },
  { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
  { name: "Fish & Seafood", icon: <FaFish /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Restaurant", icon: <FaUtensils /> },
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Chocolate", icon: <FaCookieBite /> },
];

const models = [
  { name: "CLICK&COLLECT", image: "images/click&.png", description: "Controlled temperature lockers for e-commerce" },
  { name: "UNITEDBUYBYE", image: "images/unitedbye.png", description: "The Convenient Micro Store, anytime, anywhere." },


];
function Intelligent() {
  const [selectedModels, setSelectedModels] = useState(models);

  
  return (
    <div className="w-full font-thin mb-20">
    {/* Hero Section */}
    <section
      className="relative text-center w-full h-[600px]"
      style={{
        backgroundImage: "url('images/newintelli.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    ></section>

    {/* Models Display */}
    <section className="px-6 md:px-32">
      <div className="flex flex-col items-center justify-center text-black p-6">
        <h1 className="text-3xl mb-4 md:text-4xl text-center">Intelligent Solutions</h1>
        <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
        Advanced technological solutions for food display and storage using state-of-the-art technology and artificial intelligence, which contribute to innovate the shopping experience to think about the selling point of the future.
        </p>
      </div>

      <div className="flex justify-center">
        <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
        <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline uppercase mt-6">Typologies</Link>
      </div>
    </section>

    {/* Products Grid */}
    {/* <section className="px-2 lg:px-32">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
        {selectedModels.map((model, index) => (
          <div key={index} className="text-center">
            <Link to={`/intelligentproduct/${model.name}`}>
              <div
                className="relative w-full h-80 md:mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl font-thin mb-2">{model.name}</h3>
              <p className="text-lg max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
            </Link>

            <div className="flex justify-center gap-4">
              {icons.map((icon, index) => (
                <div key={index} className="text-2xl text-gray-500">{icon.icon}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section> */}

     <section className="px-2 lg:px-32">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
              {selectedModels.map((model, index) => (
                <div key={index} className="text-center">
                 <Link to={`/${model.name.toLowerCase().replace(/\s+/g, "-")}`}>
                    <div
                      className="relative w-full h-80 md:mb-4"
                      style={{
                        backgroundImage: `url(${model.image})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        height: "300px",
                      }}
                    ></div>
                    <h3 className="text-3xl font-thin mb-2">{model.name}</h3>
                    <p className="text-lg max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
                  </Link>
    
                  {/* Small icons under each model */}
                  <div className="flex justify-center gap-4 mt-4">
                    {icons.map((icon, i) => (
                      <div key={i} className="text-2xl text-gray-500 cursor-pointer hover:text-black transition">
                        {icon.icon}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>
  </div>
);
}

export default Intelligent

// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { intelliBannerGetdata, intelliProductsGet } from "../Apihandlling";
// import { motion } from "framer-motion";

// function Intelligent() {
//   const [bannerData, setBannerData] = useState([]);
//   const [modelData, setModelData] = useState([]);

//   useEffect(() => {
//     intelliBannerGetdata()
//       .then((data) => setBannerData(data))
//       .catch((err) => console.error('Banner Fetch Error:', err));
//   }, []);

//   useEffect(() => {
//     intelliProductsGet()
//       .then((data) => {
//         console.log('Product Data:', data); // Debugging log
//         setModelData(data);
//       })
//       .catch((err) => console.error('Products Fetch Error:', err));
//   }, []);

//   return (
//     <div className="font-playfair">
//       {/* Banner Section */}
//       {bannerData.length > 0 ? (
//         <section className="relative w-full h-[500px] md:h-screen">
//           <img
//             src={bannerData[0].landingimage || ''}
//             alt="Banner"
//             className="absolute inset-0 w-full h-full object-cover"
//           />
//           {/* <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 sm:px-10 bg-black/50">
//             <h1 className="text-4xl sm:text-6xl font-bold uppercase text-white">
//               {bannerData[0].landingtext || 'Landing Text'}
//             </h1>
//             <p className="text-lg sm:text-xl text-white max-w-3xl mt-2">
//               {bannerData[0].landingdescription || 'Landing Description'}
//             </p>
//           </div> */}
//         </section>
//       ) : (
//         <section className="h-screen flex items-center justify-center bg-gray-200">
//           <motion.div
//             className="p-6 text-center"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 1, ease: 'easeInOut' }}
//           >
//             <h1 className="text-4xl md:text-6xl font-bold text-gray-800 animate-pulse">
//               Loading...
//             </h1>
//           </motion.div>
//         </section>
//       )}

//       {/* Semivertical Products */}
//         <div className=" flex flex-col items-center justify-center text-center px-6 mt-12">
//             <h1 className="text-4xl sm:text-6xl font-bold uppercase text-black">
//         {bannerData?.[0]?.landingtext || "Landing Text"}
//       </h1>
//       <p className="text-lg sm:text-xl text-black max-w-3xl mt-2">
//         {bannerData?.[0]?.landingdescription || "Landing Description"}
//       </p>
      
//                 <div className=" flex justify-center">
//               <Link to="/" className="block py-1 pl-4 hover:underline text-blue-400 mt-6">Home -</Link>
//         <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline  mt-6">Models -</Link>
//               <button to="" className=" py-1 pl-4  mt-6">Intelligent</button>
//       </div>
//             </div>
//       {/* <div className="text-center">
//         <Link to="/" className="block py-1 pl-4 hover:underline text-blue-400 mt-12">
//           Home-intelligent
//         </Link>
//       </div> */}

//       <section className="py-16 bg-white text-center px-6 sm:px-10">
//         {/* <h2 className="text-3xl sm:text-5xl font-bold text-gray-800 mb-10">Semivertical Models</h2> */}
//         <div className="container mx-auto max-w-6xl">
//           {modelData.length > 0 ? (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
//               {modelData.map((item, index) => (
//                 <div key={item._id} className="text-center flex flex-col items-center">
//                   <Link to={`/intelligent/${item._id}`} className="block">
//                     <img
//                       src={item.image}
//                       alt={item.text}
//                       className="w-full max-w-xs h-64 object-cover rounded-md"
//                     />
//                   </Link>
//                   <h3 className="text-xl font-semibold text-gray-800 mt-4">{item.text}</h3>
//                   <p className="text-gray-600 mt-2 text-sm leading-relaxed max-w-md">
//                     {item.textdescription}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-xl text-gray-500">No model data available</p>
//           )}
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Intelligent;

